type Props = {
  className?: string;
};
export const Building = (props: Props) => {
  return (
    <svg
      width="105"
      height="72"
      viewBox="0 0 105 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group 5">
        <path
          id="Shape"
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.798 45.7295C99.3001 45.7559 102.237 47.0106 102.237 48.5544C102.237 50.0982 101.027 51.3529 99.525 51.3797H94.4014C93.3352 51.7024 92.5518 52.7706 92.5518 53.9572C92.5518 55.1344 93.3227 56.1272 94.3759 56.4356H98.8471V56.4476C98.9267 56.4397 99.0075 56.4356 99.0892 56.4356C100.453 56.4356 101.559 57.5674 101.559 58.9635C101.559 60.3597 100.453 61.4915 99.0892 61.4915C99.0075 61.4915 98.9267 61.4874 98.8471 61.4795V61.4915H89.5219C88.3745 61.8341 87.3697 63.0161 87.3697 64.271C87.3697 65.5167 88.3597 66.6161 89.4966 66.9439L89.6941 66.9444C91.0357 66.9708 92.1154 68.0922 92.1154 69.4718C92.1154 70.8514 91.0357 71.9729 89.6941 71.9998H10.2765C8.93069 71.9729 7.84771 70.8514 7.84771 69.4718C7.84771 68.0922 8.93069 66.9708 10.2765 66.9444L15.915 66.9439C17.0554 66.6161 18.0485 65.5167 18.0485 64.271C18.0485 63.0161 17.0406 61.8341 15.8896 61.4915H6.51955V61.4795C6.43965 61.4874 6.35863 61.4915 6.27668 61.4915C4.90848 61.4915 3.79934 60.3597 3.79934 58.9635C3.79934 57.5674 4.90848 56.4356 6.27668 56.4356C6.35863 56.4356 6.43965 56.4397 6.51955 56.4476V56.4356H12.7316C13.788 56.1272 14.5613 55.1344 14.5613 53.9572C14.5613 52.7706 13.7755 51.7024 12.706 51.3797H9.80093C8.29418 51.3529 7.08072 50.0982 7.08072 48.5544C7.08072 47.0106 8.29418 45.7559 9.80093 45.7295H97.798ZM2.76316 71.9998C1.23711 71.9998 0 70.7452 0 69.1976C0 67.65 1.23711 66.3954 2.76316 66.3954C4.28921 66.3954 5.52632 67.65 5.52632 69.1976C5.52632 70.7452 4.28921 71.9998 2.76316 71.9998ZM102.755 67.4462H96.8832C95.6433 67.4462 94.6382 68.4656 94.6382 69.723C94.6382 70.9804 95.6433 71.9998 96.8832 71.9998H102.755C103.995 71.9998 105 70.9804 105 69.723C105 68.4656 103.995 67.4462 102.755 67.4462Z"
          fill="#CCCCCC"
        />
        <rect
          id="Rectangle"
          x="22.3613"
          y="20.4326"
          width="17.5"
          height="38.9189"
          fill="#CCCCCC"
        />
        <rect
          id="Rectangle_2"
          x="41.8057"
          y="6.81104"
          width="30.1389"
          height="52.5405"
          fill="#EEEEEE"
        />
        <path
          id="Path 4"
          d="M77.7778 51.5675L72.9167 49.6215L70 45.7297L70.9722 37.9459L74.8611 29.1891L77.7778 27.2432L81.6667 30.1621L85.5556 37.9459C85.5556 37.9459 86.5278 44.7567 85.5556 45.7297C84.5833 46.7026 83.6111 50.5945 82.6389 50.5945C81.6667 50.5945 77.7778 51.5675 77.7778 51.5675Z"
          fill="#DFF7ED"
        />
        <rect
          id="Rectangle_3"
          x="36.9443"
          y="1.9458"
          width="38.8889"
          height="4.86486"
          fill="#0495FF"
        />
        <rect
          id="Rectangle Copy 7"
          x="19.4443"
          y="15.5674"
          width="21.3889"
          height="4.86486"
          fill="#0495FF"
        />
        <rect
          id="Rectangle_4"
          x="48.6113"
          y="16.5405"
          width="4.86111"
          height="3.89189"
          fill="#DAEFFF"
        />
        <rect
          id="Rectangle Copy 6"
          x="49.5835"
          y="43.7837"
          width="13.6111"
          height="15.5676"
          fill="#DAEFFF"
        />
        <rect
          id="Rectangle Copy 2"
          x="48.6113"
          y="28.2163"
          width="4.86111"
          height="3.89189"
          fill="#DAEFFF"
        />
        <rect
          id="Rectangle Copy 4"
          x="28.1943"
          y="29.189"
          width="4.86111"
          height="3.89189"
          fill="#DAEFFF"
        />
        <rect
          id="Rectangle Copy 5"
          x="28.1943"
          y="38.9189"
          width="4.86111"
          height="3.89189"
          fill="#DAEFFF"
        />
        <rect
          id="Rectangle Copy"
          x="60.2778"
          y="16.5405"
          width="4.86111"
          height="3.89189"
          fill="#DAEFFF"
        />
        <rect
          id="Rectangle Copy 3"
          x="60.2778"
          y="28.2163"
          width="4.86111"
          height="3.89189"
          fill="#DAEFFF"
        />
        <g id="apartment">
          <path
            id="Shape_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.7696 34.8639H28.3238C27.5877 34.8639 26.9912 34.2659 26.9912 33.5288V28.3151C26.9912 27.5775 27.5882 26.98 28.3238 26.98H33.7696C34.5057 26.98 35.1027 27.5775 35.1027 28.3151V33.5288C35.1027 34.2659 34.5057 34.8639 33.7696 34.8639ZM32.437 29.6502H29.6568V32.1937H32.437V29.6502Z"
            fill="#363636"
          />
          <path
            id="Shape_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.7696 45.3932H28.3238C27.5877 45.3932 26.9912 44.7957 26.9912 44.0581V38.8449C26.9912 38.1073 27.5882 37.5098 28.3238 37.5098H33.7696C34.5057 37.5098 35.1027 38.1073 35.1027 38.8449V44.0581C35.1027 44.7957 34.5057 45.3932 33.7696 45.3932ZM32.437 40.1794H29.6568V42.723H32.437V40.1794Z"
            fill="#363636"
          />
          <path
            id="Shape_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.7418 22.4653H48.0166C47.2805 22.4653 46.6836 21.8672 46.6841 21.1302V15.6481C46.6841 14.9105 47.2805 14.313 48.0166 14.313H53.7418C54.4773 14.313 55.0743 14.9105 55.0743 15.6481V21.1302C55.0743 21.8672 54.4773 22.4653 53.7418 22.4653ZM52.4087 16.9832H49.3492V19.795H52.4087V16.9832Z"
            fill="#363636"
          />
          <path
            id="Shape_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M65.5956 22.4653H59.8667C59.1306 22.4653 58.5342 21.8672 58.5342 21.1302V15.6481C58.5342 14.9105 59.1306 14.313 59.8667 14.313H65.5956C66.3317 14.313 66.9281 14.9105 66.9281 15.6481V21.1302C66.9281 21.8672 66.3317 22.4653 65.5956 22.4653ZM64.2625 16.9832H61.1993V19.795H64.2625V16.9832Z"
            fill="#363636"
          />
          <path
            id="Shape_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.1602 25.8901H53.8848C54.6214 25.8901 55.2179 26.4882 55.2179 27.2252V32.7078C55.2179 33.4449 54.6209 34.0429 53.8848 34.0429H48.1602C47.4241 34.0429 46.8271 33.4449 46.8271 32.7078V27.2252C46.8271 26.4882 47.4241 25.8901 48.1602 25.8901ZM49.4928 31.3727H52.5523V28.5603H49.4928V31.3727Z"
            fill="#363636"
          />
          <path
            id="Shape_7"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60.0103 25.8901H65.7354C66.4715 25.8901 67.0679 26.4882 67.0679 27.2252V32.7078C67.0679 33.4449 66.4715 34.0429 65.7354 34.0429H60.0103C59.2742 34.0429 58.6777 33.4449 58.6777 32.7078V27.2252C58.6777 26.4882 59.2742 25.8901 60.0103 25.8901ZM61.3428 31.3727H64.4023V28.5603H61.3428V31.3727Z"
            fill="#363636"
          />
          <path
            id="Shape_8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82.1442 29.2344C83.9816 31.6289 85.6233 34.9335 86.5363 38.0746C87.33 40.8046 87.9557 44.7095 86.4308 47.8099C85.5364 49.6293 83.5727 51.7661 79.2766 52.1327V58.5646C79.9791 58.602 80.5372 59.1829 80.5372 59.8959C80.5372 60.6329 79.9402 61.231 79.2041 61.231H19.8405C19.1044 61.231 18.5079 60.6329 18.5079 59.8959C18.5079 59.1583 19.1044 58.5608 19.8405 58.5608H20.4364V21.622C18.7457 21.1559 17.5 19.6028 17.5 17.7626C17.5 15.5557 19.2915 13.7605 21.4934 13.7605H39.585V7.78562H39.1895C37.05 7.78562 35.3091 6.03898 35.3091 3.89255C35.3091 1.74611 37.05 0 39.1895 0H74.2039C76.3434 0 78.0843 1.74611 78.0843 3.89255C78.0843 6.03898 76.3434 7.78562 74.2039 7.78562L73.8084 7.78509V28.5599C74.9149 27.2393 76.1643 26.1586 77.7122 26.1586H77.7133C79.5399 26.1591 80.978 27.7139 82.1442 29.2344ZM39.585 16.4307H21.4934C20.761 16.4307 20.1656 17.0282 20.1656 17.7631C20.1656 18.4975 20.761 19.095 21.4934 19.095H39.585V16.4307ZM39.585 58.5608H23.1015V21.7652H39.585V58.5608ZM50.2512 58.5608H54.9449V44.5684H50.2512V58.5608ZM62.3043 58.5608H57.6106V44.5684H62.3043V58.5608ZM64.9699 58.5608H71.1428V50.0804C69.0502 48.3097 68.0758 45.5069 68.3194 41.9228C68.5166 39.0238 69.5421 35.6406 71.1428 32.5898V7.78456L62.0021 7.78188C61.266 7.78135 60.6695 7.18381 60.6701 6.44624C60.6701 5.70921 61.2671 5.11167 62.0026 5.11167H62.0032L74.2044 5.11541C74.8622 5.11541 75.4186 4.55529 75.4186 3.89255C75.4186 3.21858 74.8739 2.67021 74.2039 2.67021H39.1895C38.5195 2.67021 37.9748 3.21858 37.9748 3.89255C37.9748 4.55529 38.5312 5.11541 39.1895 5.11541H51.3865C52.1226 5.11541 52.7196 5.71295 52.7196 6.45052C52.7196 7.18755 52.1226 7.78562 51.3865 7.78562H42.2506V58.5608H47.5856V43.2333C47.5856 42.4962 48.1826 41.8982 48.9187 41.8982H63.6368C64.3729 41.8982 64.9699 42.4962 64.9699 43.2333V58.5608ZM76.611 58.5608H73.8084V51.3348C74.4731 51.7287 75.3648 52.0136 76.611 52.1301V58.5608ZM79.2766 49.4492C81.6384 49.2006 83.2396 48.2568 84.0402 46.6298C86.1014 42.4375 83.0365 34.7785 80.0314 30.8614C78.7436 29.1815 78.0597 28.8288 77.7127 28.8288H77.7122C77.361 28.8288 76.6616 29.1933 75.3286 30.9298C74.7028 31.7459 74.077 32.7374 73.5019 33.8325C73.4913 33.8528 73.4806 33.8731 73.4699 33.894C71.4061 37.8517 70.0133 43.143 71.6518 46.4743C72.4988 48.1964 74.1661 49.1916 76.6115 49.4486V47.0312L73.9896 45.1606C73.39 44.733 73.2503 43.8992 73.6773 43.2985C74.1042 42.6983 74.9363 42.5582 75.5359 42.9858L76.6115 43.7533V42.0083L74.6431 40.1285C74.1106 39.6197 74.0904 38.7747 74.5983 38.2413C75.1058 37.7074 75.9495 37.6871 76.4825 38.1959L76.6115 38.3194V35.9009C76.6115 35.1639 77.208 34.5658 77.9441 34.5658C78.6802 34.5658 79.2766 35.1639 79.2766 35.9009V40.1686L79.4104 40.0414C79.9434 39.5331 80.7872 39.554 81.2946 40.0879C81.8021 40.6224 81.7813 41.4674 81.2477 41.9757L79.2766 43.8549V49.4492Z"
            fill="#363636"
          />
          <path
            id="Path"
            d="M56.723 5.11523H56.6963C55.9602 5.11523 55.3638 5.71277 55.3638 6.45034C55.3638 7.18737 55.9602 7.78545 56.6963 7.78545H56.723C57.4591 7.78545 58.0555 7.18737 58.0555 6.45034C58.0555 5.71277 57.4591 5.11523 56.723 5.11523Z"
            fill="#363636"
          />
        </g>
      </g>
    </svg>
  );
};
